import { EAppActions, IAppState, TAppAction } from "./types";

export const appReducer = (
  state: IAppState,
  action: TAppAction,
): IAppState => {
  switch (action.type) {
    case EAppActions.SET_BLAZE:
      return { ...state, blaze: action.payload };
    case EAppActions.SET_PROVIDER:
      return { ...state, provider: action.payload };
    case EAppActions.SET_ORDER_ENCRYPTION_KEY:
      return { ...state, orderEncryptionKey: action.payload };
    default:
      throw new Error("No matching action.");
  }
};
